import React, { useState } from 'react';
import {
    Text, Stack, Link, PersonaSize, Persona, PersonaPresence,
    Dialog, DialogFooter, PrimaryButton, DefaultButton, DialogType, Icon, Image, ImageFit
} from '@fluentui/react';
import { useSelector } from "react-redux";
import URL, { onSignOut } from "../../Containers/MainController";
import COLOR from "../../Styles/Colors";

const Account = () => {
    const [hideDialog, setHideDialog] = useState(true);
    const user = useSelector(state => state.UserInfoEnter);

    const onHideDialog = () => setHideDialog(true);
    const onShowDialog = () => setHideDialog(false);

    // const onChangePasswordPress = () => onOpenRightPanel('changePasswordEnter')

    return (
        <div className='modal-content-container'>
            <div className='animated-panel'>
                <Stack horizontalAlign='center' styles={styles.container} tokens={{ childrenGap: 16 }}>
                    <Persona
                        text={user.FullName}
                        size={PersonaSize.size72}
                        presence={PersonaPresence.online}
                        hidePersonaDetails={true}
                    />
                    <Stack horizontalAlign='center' tokens={{ childrenGap: 5 }}>
                        <Stack style={{ flexDirection: 'row' }}>
                            <Icon iconName='UserFollowed' styles={styles.titleIcon} />
                            <Text variant='mediumPlus'>{user.FullName}</Text>
                        </Stack>
                        <Stack style={{ flexDirection: 'row' }}>
                            <Icon iconName='Phone' styles={styles.titleIcon} />
                            <Text variant='medium'>{user.PhoneNumber}</Text>
                        </Stack>
                        <Stack style={{ flexDirection: 'row' }}>
                            <Icon iconName='Location' styles={styles.titleIcon} />
                            <Text variant='medium'>{user.tendvhc}</Text>
                        </Stack>

                    </Stack>
                    <Stack tokens={{ childrenGap: 5 }} horizontalAlign='center'>
                        {/* <Link onClick={onChangePasswordPress}>  Đổi mật khẩu </Link> */}
                        <Link onClick={onShowDialog}>Đăng xuất</Link>
                    </Stack>
                </Stack>
            </div>
            <Dialog
                hidden={hideDialog}
                onDismiss={onHideDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Đăng xuất ',
                    closeButtonAriaLabel: 'Đóng',
                    subText: 'Bạn có muốn đăng xuất tài khoản ?',
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={onSignOut} text="Đăng xuất" />
                    <DefaultButton onClick={onHideDialog} text="Hủy bỏ" />
                </DialogFooter>
            </Dialog>

            <Stack style={styles.inline} />
            <Text style={{ textAlign: 'center', color: 'gray' }}>Tải ứng dụng VNPT - ILIS để có trải nghiệm tốt hơn trên thiết bị di động.</Text>
            <Stack style={{ flexDirection: 'row', marginTop: 10, justifyContent: 'center' }}>
                <a href={URL.urlDownloadIOS}>
                    <Image
                        src={require("../../Assets/DownIOS.png")}
                        imageFit={ImageFit.contain}
                        width={100}
                        height={40}
                    />
                </a>
                <Stack style={{ width: 30 }} />
                <a href={URL.urlDownloadAndroid}>
                    <Image
                        src={require("../../Assets/DownAndroid.png")}
                        imageFit={ImageFit.contain}
                        width={100}
                        height={40}
                    />
                </a>
            </Stack>
        </div>
    )
};

export default Account;

const styles = {
    container: {
        root: {
            marginTop: 30,
        }
    },
    titleIcon: {
        root: {
            color: COLOR.darkGray,
            fontSize: 12,
            marginRight: 5,
            marginTop: 4
        }
    },
    inline: {
        height: 1,
        backgroundColor: '#BDBDBD',
        width: '100%',
        marginTop: 30,
        marginBottom: 20
    }
};

